import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { Calendar } from "../../Calendar";
import * as CalendarUtils from "../../Calendar/CalendarUtils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { MobilePopup } from "../../../internal/MobilePopup";
import { DateInput } from "../../DateInput";
import { Button } from "../../Button";
import { useLocaleForControl } from "../../../lib/locale/useLocaleForControl";
import { useEffectWithoutInitCall } from "../../../hooks/useEffectWithoutInitCall";
import { DatePickerLocaleHelper } from "../locale";
import { styles } from "../MobilePicker.styles";
import { getMobilePickerTheme } from "../getMobilePickerTheme";
export var MobilePickerDataTids = {
  input: 'MobilePicker__input',
  today: 'MobilePicker__today'
};
export var MobilePicker = function MobilePicker(props) {
  var locale = useLocaleForControl('DatePicker', DatePickerLocaleHelper);
  var theme = getMobilePickerTheme(useContext(ThemeContext));

  var onValueChange = function onValueChange(date) {
    if (props.onValueChange) {
      props.onValueChange(date);
    }

    if (props.onCloseRequest) {
      props.onCloseRequest();
    }
  };

  var inputRef = useRef(null);
  useLayoutEffect(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  var calendarRef = useRef(null);

  var _useState = useState(function () {
    return CalendarUtils.getTodayDate();
  }),
      today = _useState[0];

  var onTodayClick = function onTodayClick() {
    if (calendarRef.current) {
      calendarRef.current.scrollToMonth(today.month, today.year);
    }
  };

  useEffectWithoutInitCall(function () {
    if (props.value && calendarRef.current) {
      var month = +props.value.substring(3, 5);
      var year = +props.value.substring(6);
      calendarRef.current.scrollToMonth(month, year);
    }
  }, [props.value]);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(MobilePopup, {
    opened: true,
    headerChildComponent: /*#__PURE__*/React.createElement(DateInput, {
      value: props.value || '',
      width: "100%",
      withIcon: true,
      ref: inputRef,
      minDate: props.minDate,
      maxDate: props.maxDate,
      onValueChange: props.onValueChange,
      size: "medium",
      warning: props.warning,
      error: props.error,
      "data-tid": MobilePickerDataTids.input
    }),
    footerChildComponent: props.enableTodayLink && /*#__PURE__*/React.createElement(Button, {
      size: "medium",
      onClick: onTodayClick,
      "data-tid": MobilePickerDataTids.today
    }, locale.today),
    onCloseRequest: props.onCloseRequest
  }, /*#__PURE__*/React.createElement(Calendar, {
    ref: calendarRef,
    value: props.value,
    className: styles.calendarRoot(),
    minDate: props.minDate,
    maxDate: props.maxDate,
    onValueChange: onValueChange,
    isHoliday: props.isHoliday,
    renderDay: props.renderDay,
    onMonthChange: props.onMonthChange
  })));
};